import Paper from "@material-ui/core/es/Paper/Paper";
import * as KJUR from "jsrsasign";
import React from "react";

import ActionBar from "../components/ActionBar";
import Loader from "../components/Loader";
import VLButton from "../components/VLButton";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

export default class ResetScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: true, rememberMe: true, error: ""};
    }

    resetUsername = () => {
        let jwt = this.token();
        let obj = KJUR.jws.JWS.readSafeJSONString(KJUR.b64utoutf8(jwt.split(".")[1]));
        return obj.username;
    };

    token = () => {
        return Util.getValue("token");
    };

    render() {
        return (
            <div>
                <ActionBar title="Vision Link - Reset Password" hideAll={true}/>
                {this.renderTextAlert()}
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    width: "100%",
                    justifyContent: "center",
                    minHeight: "calc(100vh - 120px)",
                    alignItems: "center",
                    padding: 16
                }}>
                    <Paper style={{width: "15cm", padding: 32, borderRadius: 16}}>
                        <div><img src="https://api.vision-link.co.uk/app_logo/VL.png"
                                  style={{width: "calc(100% - 60px)", margin: 30}}/></div>
                        <p style={{textAlign: "center"}}>Resetting password for {this.resetUsername()}</p>
                        <br/>
                        {this.renderForm()}
                        <br/><br/>
                    </Paper>
                    <br/><br/><br/>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    warnIe = () => {
        if (Util.isIE()) {
            return <p style={{textAlign: "center", color: "red"}}>Warning: You seem to be using Internet Explorer. We
                recommend you use Google Chrome for the best experience.</p>;
        }
    };

    renderForm = () => {
        return (
            <div>

                <p className="nomargin"><b>New Password</b></p>
                <input name="password1" type="password" className="vl-input wide top8" placeholder="Password"
                       value={this.state.password1} onChange={this.handleInputChange}/>
                <br/><br/>
                <p className="nomargin"><b>Confirm Password</b></p>
                <input name="password2" type="password" className="vl-input wide top8" placeholder="Password"
                       value={this.state.password2} onChange={this.handleInputChange}/>

                <p style={{color: "red", textAlign: "center"}}>{this.state.error}</p>

                <VLButton title="Reset" className="wide top8" onClick={this.login}/>
            </div>
        );
    };

    login = () => {
        let password1 = this.state.password1;
        let password2 = this.state.password2;
        if (password1 != password2) {
            this.setState({error: "Passwords do not match"});
            return;
        }
        this.setState({error: ""});
        API.POST("account/resetPassword", {resetToken: this.token(), password: password1}, result => {
            if (result.success) {
                this.basicAlert("Your password has been reset. You may now log in.", () => {
                    window.open("/login", "_self");
                });
            } else {
                this.setState({error: result.error});
            }
        });
    };

}
